module.exports = __webpack_public_path__ + "images/apple-touch-icon-72x72-558c0a42ccf37077d3d7c4621ee76890.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/apple-touch-icon-72x72.png
// module id = ./src/images/favicons/apple-touch-icon-72x72.png
// module chunks = 1